import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoStepRightButtons]',
  host: {
    class: 'xpo-StepButtons--right',
  },
})
export class XpoStepRightButtonsDirective {}
